var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,_vm._g(_vm._b({tag:"component",attrs:{"name":_vm.transitionName},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }